export default __webpack_public_path__ + "static/media/clinic.cf65e256.jpg";